import { Component } from '@angular/core';
import { BRANDING } from '../../branding';

/** Square logo icon (collapsed sidebar). Shows BRANDING.logoMark, or BRANDING.logoIcon when no image is set. */
@Component({
  selector: 'app-brand-mark',
  host: { class: 'brand-mark', '[class.brand-mark--image]': '!!brand.logoMark', 'aria-hidden': 'true' },
  template: `@if (brand.logoMark) {
      <img [src]="brand.logoMark" alt="" />
    } @else {
      <i [class]="brand.logoIcon"></i>
    }`,
})
export class BrandMark {
  protected readonly brand = BRANDING;
}
